module.exports = __webpack_public_path__ + "img/6.ced3497e.jpg";